import customerFragment from '../fragments/customer'

const query = `query Customer($customerAccessToken: String!) {
  customer(customerAccessToken: $customerAccessToken) 
    ${customerFragment}
}`

export default query
